import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {InterestResponse} from '../model/interestResponse';
import {InterestRequest} from '../model/interestRequest';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {PmsList} from '../model/pmsList';

@Injectable()
export class InterestService {

  constructor(private httpClient: HttpClient) { }

  getAvailablePmsList(): Observable<PmsList> {
      const headers = new HttpHeaders({'x-api-key': environment.apiKey});
      const url = `${environment.apiUrl}/interest/pms-list`;
      return this.httpClient.get<PmsList>(url, { headers: headers });
  }

  sendInterestRequest(request: InterestRequest): Observable<InterestResponse> {
    const headers = new HttpHeaders({'x-api-key': environment.apiKey, 'Content-Type': 'application/json'});
    const url = `${environment.apiUrl}/interest`;
    return this.httpClient.post<InterestResponse>(url, request, { headers: headers });
  }
}



// WEBPACK FOOTER //
// /Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/src/app/services/interest.service.ts